// 销售订单状态
export const SellOrderStatusList = [
  { value: "draft", text: "草稿" },
  { value: "auditing", text: "审核中" },
  { value: "passed", text: "审核通过" },
  { value: "confirming_deliver_order", text: "发货确认中" },
  { value: "notified_delivery", text: "已通知发货" },
  { value: "part_delivered", text: "已部分发货" },
  { value: "completed", text: "已完成" },
  { value: "abandoned", text: "已作废" },
];

export const SellOrderStatusMap = SellOrderStatusList.reduce((acc, curr) => {
  acc[curr.value] = curr.text;
  return acc;
}, {});

export const SellOrderDisallowCompleteStatusList = ['completed', 'abandoned'];
export const SellOrderDisallowDeleteStatusList = ['completed', 'abandoned'];

// 发货通知状态 abandoned已废弃，draft草稿，auditing 审核中(已锁库存)，confirmed已扣减库存，notified通知发货，preparation备货中，completed完成
export const DeliveryNoticeStatusList = [
  {
    value: "abandoned",
    label: "已废弃",
  },
  {
    value: "draft",
    label: "草稿",
  },
  {
    value: "auditing",
    label: "审核中(已锁库存)",
  },
  {
    value: "confirmed",
    label: "已扣减库存",
  },
  {
    value: "notified",
    label: "通知发货",
  },
  {
    value: "preparation",
    label: "备货中",
  },
  {
    value: "completed",
    label: "完成",
  },
];

export const DeliveryNoticeStatusMap = DeliveryNoticeStatusList.reduce((acc, curr) => {
  acc[curr.value] = curr.label;
  return acc;
}, {});


// 发货通知结算状态 unsettled未结算，generated已生成结算单，collected已收款
export const DeliveryNoticeSettlementStatusList = [
  {
    value: "unsettled",
    label: "未结算",
  },
  {
    value: "generated",
    label: "已生成结算单",
  },
  {
    value: "collected",
    label: "已收款",
  },
];

export const DeliveryNoticeSettlementStatusMap = DeliveryNoticeSettlementStatusList.reduce((acc, curr) => {
  acc[curr.value] = curr.label;
  return acc;
}, {});


// 销售类型
export const SellTypeList = [
  {
    value: 1,
    label: "销售",
  },
  {
    value: 2,
    label: "赠送",
  },
];

export const SellTypeMap = SellTypeList.reduce((acc, curr) => {
  acc[curr.value] = curr.label;
  return acc;
}, {});


// 结算类型 结算类型: sell 销售结算，largess 赠品结算, return 退货结算，adjustment 人工调整（维修费
export const SettlementTypeList = [
  {
    value: "sell",
    label: "销售结算",
  },
  {
    value: "largess",
    label: "赠品结算",
  },
  {
    value: "return",
    label: "退货结算",
  },
  {
    value: "adjustment",
    label: "人工调整",
  },
];

export const SettlementTypeMap = SettlementTypeList.reduce((acc, curr) => {
  acc[curr.value] = curr.label;
  return acc;
}, {});


// 结算单状态 abandoned 已作废，unconfirmed 待确认，confirmed 已确认，collected 已收款
export const SettlementOrderStatusList = [
  {
    value: "abandoned",
    label: "已作废",
  },
  {
    value: "unconfirmed",
    label: "待确认",
  },
  {
    value: "confirmed",
    label: "已确认",
  },
  {
    value: "collected",
    label: "已收款",
  },
];

export const SettlementOrderStatusMap = SettlementOrderStatusList.reduce((acc, curr) => {
  acc[curr.value] = curr.label;
  return acc;
}, {});

export const SettlementOrderDisallowEditStatusList = ['abandoned', 'confirmed', 'collected'];
export const SettlementOrderDisallowDeleteStatusList = ['abandoned', 'confirmed', 'collected'];
export const SettlementOrderDisallowConfirmStatusList = ['abandoned', 'confirmed', 'collected'];
